import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpApi from 'i18next-http-backend'
import moment from 'moment'

import deMessages from "devextreme/localization/messages/de.json";
import enMessages from "devextreme/localization/messages/en.json";
import { locale, loadMessages } from 'devextreme/localization'

import namespaces from '../i18n-ns.json'

i18n
    .use(initReactI18next)
    .use(LanguageDetector)
    .use(HttpApi)
    .init({
        returnNull: false,
        fallbackLng: 'en',
        keySeparator: '.',
        ns: namespaces,
        defaultNS: 'global',
        interpolation: {
            escapeValue: false,
            format: (value, format, lng) => {
                switch (format) {
                    case 'date':
                        return moment(value).format('ll')
                    case 'time':
                        return moment(value).format('LT')
                    case 'datetime':
                        return moment(value).format('lll')
                    case 'lowerf':
                        return value.charAt(0).toLowerCase() + value.slice(1)
                    case 'upperf':
                        return value.charAt(0).toUpperCase() + value.slice(1)
                    default:
                        return value
                }
            }
        },
        detection: {
            order: ['querystring', 'localStorage'],
            lookupLocalStorage: 'i18nLang',
            lookupQuerystring: 'lng',
            caches: ['localStorage'],
        },
        backend: {
            loadPath: '/i18n/{{lng}}/{{ns}}.json'
        },
        react: {
            bindI18n: 'languageChanged',
            bindI18nStore: '',
        }
    }, () => {
        console.log('DevExtreme Language', i18n.language)
        loadMessages(deMessages)
        loadMessages(enMessages)
        locale(i18n.language)
  })

export default i18n
